import { Outlet } from "react-router-dom";

const AdminPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default AdminPage;
